export default __webpack_public_path__ + "static/media/new-brand.4ba66d15.svg";